import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const deleteAdmin = async (id: string) => {
  const res = await apiManager.delete(`/admin/admin/${id}/delete`);
  return res;
};


export const useDeleteAdmin = () =>
  useMutation({
    mutationFn: async (id: string) => {
      const res = await apiClient.delete(ENDPOINTS.ADMIN.DELETE_ADMIN(id));
      return res.data;
    },
  });